
import { computed, defineComponent } from '@nuxtjs/composition-api';

const variations = {
  blue: {
    base: 'bg-blue-500 text-white',
  },
  white: {
    base: 'text-white ',
    active: 'text-blue',
  },
};

export default defineComponent({
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    variation: {
      type: String,
      default: 'blue',
    },
    static: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const tagClasses = computed(() => {
      let classes =
        variations[props.variation][props.isActive ? 'active' : 'base'];

      if (!props.static) classes = `${classes} cursor-pointer`;

      return classes;
    });

    return {
      tagClasses,
    };
  },
});
